const headerCartBubble = document.querySelector('.header-menu__link--icon-cart');
const headerCartCount = document.querySelector('.header__cart-count');

if (headerCartBubble && headerCartCount) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                headerCartBubble.click();
            }
        }
    });

    observer.observe(headerCartCount, { childList: true, characterData: true, subtree: true });

    console.log('MutationObserver is watching for changes in cart count');
}

const initialTime = 10 * 60;
let timerElement = document.getElementById('custom-cart-timer');

const loadTimerState = () => {
  const savedTime = localStorage.getItem('countdown');
  return savedTime !== null ? parseInt(savedTime, 10) : initialTime;
};

const saveTimerState = (time) => {
  localStorage.setItem('countdown', time);
};

let timeLeft = loadTimerState();

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${mins}:${secs}`;
};

const updateTimerDisplay = () => {
  timerElement.textContent = formatTime(timeLeft);
};

const resetTimer = () => {
  timeLeft = initialTime;
  saveTimerState(timeLeft);
  updateTimerDisplay();
};

const fetchCartItemCount = async () => {
  try {
    const response = await fetch('/cart.js');
    const cartData = await response.json();
    return cartData.item_count;
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return 0;
  }
};

const countdown = async () => {
  const cartItemCount = await fetchCartItemCount();
  if (cartItemCount === 0) {
    resetTimer();
    return;
  }

  if (timeLeft > 0) {
    timeLeft -= 1;
    saveTimerState(timeLeft);
    updateTimerDisplay();
  } else {
    resetTimer();
  }
};

setInterval(() => {
  if(!timerElement) {
    timerElement = document.getElementById('custom-cart-timer');
  } else {
    updateTimerDisplay();
    countdown();
  }
}, 1000);